<template>
  <div>
    <div class="card">
      <div
        class="card-header bg-primary font-weight-bold text-white"
        style="display: flex; align-items: center"
      >
        Kehadiran Peserta
        <Button
          class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
          @click="$router.go(-1)"
          >Kembali</Button
        >
      </div>
      <form class="card-body">
        <div>
          <CRow class="mb-3">
            <div class="col-sm-12 col-xl-12">
              <div class="form-group">
                <label for="" class="font-weight-bold">Pilih Hari</label>
              <select name="" class="form-control col-md-12" id="">
                <option value="">Senin</option>
                <option value="">Selasa</option>
                <option value="">Rabu</option>
                <option value="">Kamis</option>
                <option value="">Jumat</option>
                <option value="">Sabtu</option>
                <option value="">Minggu</option>
              </select>
              </div>
            </div>
          </CRow>
          <div class="mt-3">
            <CRow>
              <div class="col-sm-12 col-xl-6">
                <div class="form-group">
                  <CSelect
                    class="float-left"
                    label="Data Per Halaman"
                    placeholder="Data Per Halaman"
                    @change="changePageSize"
                    :options="[10, 25, 100, 'Semua Data']"
                  />
                </div>
              </div>

              <div class="col-sm-12 col-xl-4 ml-auto">
                <div class="form-group">
                  <CInput
                    aria-label="Pencarian"
                    class="float-right"
                    placeholder="Cari Data .."
                    v-model="searchPelatihan"
                  />
                </div>
              </div>
            </CRow>
            <table class="table"> 
              <thead>
                <tr>
                  <th>No</th>
                  <th>No Anggota</th>
                  <th>Nama</th>
                  <th>Tanggal Daftar</th>
                  <th>
                    <input
                      id="terms"
                      type="checkbox"
                      @click="selectAll"
                      v-model="allSelected"
                    />
                    Hadir
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in items" :value="data.id_pelatihan_peserta" :key="data">
                  <td>{{index+1}}</td>
                  <td>08383458</td>
                  <td>{{data.nama_lengkap }}</td>
                  <td>02-02-2020</td>
                  <td scope="row">
                    <input id="terms" type="checkbox" :checked="checked" />
                  </td>
                </tr>
              </tbody>
            </table>
            <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
          </div>
        </div>

      </form>
        <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3 mb-4">
          <Button
            style="float: right"
            class="btn btn-md btn-success px-4 py-2"
            type="submit"
            color="success"
            >Simpan</Button
          >
          <br />
        </div>
    </div>
  </div>
</template>

<script>
import DataPesertaService from "../../../../services/pelatihan/data-peserta.service";
import DataKehadiranPeserta from "../../../../services/pelatihan/kehadiran-peserta.service";
import DataAnggotaService from "../../../../services/keanggotaan/data-anggota.service";
import { AlertUtils } from "../../../../mixins/AlertUtils"; 
import { Pagination } from "../../../../mixins/Pagination";
export default {
    mixins: [
    AlertUtils, 
    Pagination
  ],
  data() {
    return {
      formData: [
        {
          item: false,
          idWorkshopPelatihan: "",
          id_workshop_pelatihan: ""
        },
      ],
      items: [],
      dataKehadiran: [],
      checked: false,
      selected: [],
      allCheckSelected: false,
      allSelected: false,
      collapseDuration: 0,
      pageSize: 10,
      content: []
    };
  },

  mounted() {
    this.getKehadiranPeserat();
    this.getData("0",
      this.pageSize,
      this.idWorkshopPelatihan,
      this.searchPelatihan);
  },

  methods: {
    selectAll: function () {
      if (this.allSelected) {
        // comment console console.log(this.allCheckSelected + " INI ALL CHECKED");
        // comment console console.log(this.checked + " INI CHECKED");
          this.allCheckSelected = false;
        this.checked = false;
      } else {
        // comment console console.log(this.allCheckSelected + " INI ALL CHECKED");
        // comment console console.log(this.checked + " INI CHECKED");
          this.allCheckSelected = true;
        this.checked = true;
      }
    },

    getData(currentPage, pageSize, idWorkshopPelatihan, filter) {
      DataPesertaService.getDataPeserta(currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter)
      .then(response => {
        this.item = response.data.data.content;
        // comment console console.log(response.data.data.content);
      })
    },

    getKehadiranPeserat() {
      DataKehadiranPeserta.getKehadiranPeserta()
      .then(response => {
        this.dataKehadiran = response.data.data;
        // comment console console.log(response.data.data);
      })
    },
  
    getDataAnggota(tahun,kategori) {
        let loader = this.$loading.show({
          container: false ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel
        });
        var vm = this
        
        DataAnggotaService.getDataAnggotaPeriodeTahunKategori(tahun, kategori)
          .then(response => {
            // comment console console.log(response)
            this.dataAnggota = response.data.data;
            for (let index = 0; index < this.dataAnggota.length; index++) {
              this.dataUser.push(
                {
                  id_user : null,
                  checked : false,
                }
              );
            }

            loader.hide()
          }).catch(error => {
            // comment console console.log(error);
            loader.hide()

        })
    },
    selectAll: function() {
          if(this.allSelected) {
            this.allCheckSelected = false;
          } else {
            this.allCheckSelected = true;
          }


          if (!this.allSelected) {
            for (let index = 0; index < this.dataAnggota.length; index++) {

                this.dataUser[index].id_user = this.dataAnggota[index].id_user
                this.dataUser[index].checked = true
            }
          } else {
            for (let index = 0; index < this.dataAnggota.length; index++) {

                this.dataUser[index].id_user = null
                this.dataUser[index].checked = false
            }
          }
            
    },
    select: function(e, index) {
          if(!e.target.checked) {
            this.allSelected = false
            this.dataUser[index].id_user = null
            this.dataUser[index].checked = false 
          } else {
            var data = e.target.value;
            this.dataUser[index].id_user = data 
            this.dataUser[index].checked = true 
          }
    },
  },
};
</script>